'use es6';

import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
const Footer = props => /*#__PURE__*/_jsx(UIFlex, Object.assign({}, props, {
  align: "baseline",
  justify: "between",
  wrap: "wrap"
}));
export default Footer;